import axios from 'axios';
import config from '../../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const exhibitionPhotoService = {
  // Get all photos for an exhibition
  getPhotosByExhibition: async (exhibitionId) => {
    const response = await api.get(`/exhibitions/${exhibitionId}/photos`);
    const data = response.data;
    console.log('getPhotosByExhibition response:', data);
    
    // API response formatı: direkt array veya { data: [...], log: {...}, message: "..." }
    if (Array.isArray(data)) {
      return data; // Direkt array
    } else if (data && data.data && Array.isArray(data.data)) {
      return data.data; // Wrapped format
    } else {
      console.error('Invalid data format:', data);
      return [];
    }
  },

  // Add photo to exhibition
  addPhoto: async (exhibitionId, formData) => {
    console.log('Received FormData:', formData);
    console.log('FormData type:', typeof formData);
    console.log('Is FormData instance:', formData instanceof FormData);
    
    // FormData zaten hazır geldiği için tekrar oluşturmuyoruz
    // Debug FormData contents
    console.log('FormData entries:');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    console.log('Uploading to:', `${config.API_URL}/exhibitions/${exhibitionId}/photos`);

    const response = await api.post(`/exhibitions/${exhibitionId}/photos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    console.log('Upload response:', response.data);
    return response.data;
  },

  // Delete photo
  deletePhoto: async (photoId) => {
    const response = await api.delete(`/exhibitions/photos/${photoId}`);
    return response.data;
  },

  // Update photo order
  updatePhotoOrder: async (photoId, displayOrder) => {
    const response = await api.put(`/exhibitions/photos/${photoId}/order`, {
      display_order: displayOrder
    });
    return response.data;
  }
};

export default exhibitionPhotoService; 